// form fixes
const observer = new MutationObserver(() => {
    const label = document.querySelector('form.g-container label[tabindex="0"]');
    if (label) {
        label.removeAttribute('tabindex');
    }

    const removeBtn = document.querySelector('div[data-file-remove]');
    if (removeBtn) {
        removeBtn.setAttribute('tabindex', '0');
        removeBtn.setAttribute('role', 'button'); // for screen readers

        // Allow Enter/Space to activate it
        removeBtn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                removeBtn.click();   // simulate click, triggers plugin removal
                document.querySelector('.gfb__dropzone--placeholder--button').focus();
            }
        });            
    }
});
observer.observe(document.body, { childList: true, subtree: true });

// mp4 playback toggle buttons — supports multiple instances per page
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('div.video-playback-toggle').forEach(function(toggle) {
        var btn = toggle.querySelector('button');
        var video = toggle.nextElementSibling;
        if (!btn || !video || video.tagName !== 'VIDEO') return;
        btn.addEventListener('click', function() {
            if (video.paused) {
                video.play();
                btn.className = 'video-playback-toggle--pause';
                btn.setAttribute('aria-label', 'Pause video');
            } else {
                video.pause();
                btn.className = 'video-playback-toggle--play';
                btn.setAttribute('aria-label', 'Play video');
            }
            video.controls = false;
        });
    });
});

// Cart remove buttons (high-31): handle navigation for button[data-url] in .cart__remove
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.cart__remove button[data-url]');
  if (!btn) return;
  window.location.href = btn.dataset.url;
});

// Product grid image keyboard navigation
// Arrow right/left cycle through primary/secondary images; focus never auto-swaps the image.
(function() {
    var liveRegion = document.createElement('div');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.className = 'visually-hidden';
    document.body.appendChild(liveRegion);

    function announceImageAlt(mask, showSecondary) {
        var img;
        if (showSecondary) {
            img = mask.querySelector('.grid-product__secondary-image img');
        } else {
            var secondaryContainer = mask.querySelector('.grid-product__secondary-image');
            img = Array.prototype.find.call(
                mask.querySelectorAll('img'),
                function(el) { return !secondaryContainer || !secondaryContainer.contains(el); }
            );
        }
        liveRegion.textContent = (img && img.alt) ? img.alt : '';
    }

    document.addEventListener('keydown', function(e) {
        var isArrow = e.key === 'ArrowRight' || e.key === 'ArrowLeft';
        var isActivate = e.key === 'Enter' || e.key === ' ';
        if (!isArrow && !isActivate) return;
        if (!e.target.matches('.grid-product__image-mask[tabindex]')) return;
        if (!e.target.querySelector('.grid-product__secondary-image')) return;
        e.preventDefault();
        var showSecondary;
        if (isActivate) {
            showSecondary = !e.target.classList.contains('pbk-image-active');
        } else {
            showSecondary = e.key === 'ArrowRight';
        }
        e.target.classList.toggle('pbk-image-active', showSecondary);
        announceImageAlt(e.target, showSecondary);
    });

    document.addEventListener('focusin', function(e) {
        if (!e.target.matches('.grid-product__image-mask[tabindex]')) return;
        announceImageAlt(e.target, false);
    });

    document.addEventListener('focusout', function(e) {
        if (!e.target.matches('.grid-product__image-mask[tabindex]')) return;
        e.target.classList.remove('pbk-image-active');
        liveRegion.textContent = '';
    });
}());

// Reviews.io rating snippet accessible name (high-89)
// ruk_rating_snippet is populated by Reviews.io JS after page load. The raw
// text uses star glyphs and "|" that screen readers don't handle well, so we
// wait for the widget to render and set a clean aria-label on the inner anchor.
(function() {
  'use strict';
  var container = document.querySelector('.ruk_rating_snippet');
  if (!container) return;

  var observer = new MutationObserver(function() {
    var link = container.querySelector('a, button');
    if (!link) return;
    if (link.getAttribute('aria-label')) { observer.disconnect(); return; }
    var text = (container.textContent || '').trim();
    var match = text.match(/(\d[\d.]*)[^\d]*(\d+)\s*[Rr]eview/);
    if (!match) return; // text not ready yet, wait for next mutation
    observer.disconnect();
    link.setAttribute('aria-label', match[1] + ' out of 5 stars, ' + match[2] + ' reviews');
  });

  observer.observe(container, { childList: true, subtree: true });
}());

// a11y debug, highlight currently tabbed element
// (function () {
//     let last;

//     document.addEventListener("focusin", e => {
//         // Remove outline from previously focused element
//         if (last) last.style.outline = "";

//         // Add outline to new focused element
//         e.target.style.outline = "3px solid red";
//         last = e.target;
//     });
// })();